import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

/**
 * Fires a /track/pageview ping every time the SPA route changes.
 * Mounted once, near the top of App.js, inside <BrowserRouter>.
 *
 * - Dedupes back-to-back identical paths (React Router can fire twice on mount)
 * - Never throws — tracking failures must not break the app
 * - Skips localhost / dev (process.env.NODE_ENV !== "production") so our
 *   own browsing doesn't pollute the dashboard
 */
export default function PageviewTracker() {
  const location = useLocation();
  const lastPathRef = useRef(null);

  useEffect(() => {
    const path = location.pathname + (location.search || "");
    if (lastPathRef.current === path) return;
    lastPathRef.current = path;
    // Track on both preview and production — we want to see data flowing in
    // the dashboard during development too. The admin tab can filter if needed.
    api.post("/track/pageview", {
      path,
      referrer: document.referrer || null,
      screen_w: window.innerWidth || null,
    }).catch(() => { /* never throw */ });
  }, [location.pathname, location.search]);

  return null;
}
